export const COLLECTION_KEYS = {
  empresa: {
    trabajadores: {
      registros: "riskmann_trabajadores",
    },
    planesAccion: {
      registros: "riskmann_planes_accion",
      actividades: {
        registros: "riskmann_planes_accion_actividades",
      },
    },
  },
  panelAdministrativo: {
    seguridadVial: {
      formatos: {
        plantillas: {
          registros: "riskmann_seguridadvial_formatos_plantillas",
        },
      },
      cuestionarios: {
        plantillas: {
          registros: "riskmann_seguridadvial_cuestionarios_plantillas",
        },
      },
    },
  },
  rutogramas: {
    registros: "riskmann_rutogramas",
  },
  seguridadVial: {
    conductores: {
      registros: "riskmann_seguridadvial_conductores",
      licencias: {
        registros: "riskmann_seguridadvial_conductores_licencias",
      },
      examenes: {
        registros: "riskmann_seguridadvial_conductores_examenes",
      },
      capacitaciones: {
        registros: "riskmann_seguridadvial_conductores_capacitaciones",
      },
      revisiones: {
        registros: "riskmann_seguridadvial_conductores_revisiones",
      },
    },
    vehiculos: {
      registros: "riskmann_seguridadvial_vehiculos",
      documentos: {
        registros: "riskmann_seguridadvial_vehiculos_documentos",
      },
      revisiones: {
        registros: "riskmann_seguridadvial_vehiculos_revisiones",
      },
      mantenimientos: {
        registros: "riskmann_seguridadvial_vehiculos_mantenimientos",
      },
      siniestros: {
        registros: "riskmann_seguridadvial_vehiculos_siniestros"
      },
    },
    formatos: {
      registros: "riskmann_seguridadvial_formatos",
    },
    cuestionarios: {
      registros: "riskmann_seguridadvial_cuestionarios",
    },
    inspecciones: {
      registros: "riskmann_seguridadvial_inspecciones",
      exentos: {
        registros: "riskmann_seguridadvial_inspecciones_exentos",
      }
    },
    aptitudes: {
      registros: "riskmann_seguridadvial_conductores_aptitudes",
    },
    infografias: {
      registros: "riskmann_seguridadvial_infografias",
    },
    // Informe Anual de Autogestión del PESV (issue #1187, RF-12)
    informesAutogestion: {
      registros: "riskmann_seguridadvial_informes_autogestion",
      // Borrador del formulario previo, uno por espacio y vigencia (RF-06)
      borradores: "riskmann_seguridadvial_informes_autogestion_borradores",
    },
    planesDesplazamientos: {
      registros: "riskmann_seguridadvial_planes_desplazamientos_terrestres",
      reportes: {
        registros: "riskmann_seguridadvial_planes_desplazamientos_terrestres_reportes",
      },
    },
  },
  metadataFirestore: {
    seguridadVial: {
      inspecciones: "riskmann_metadata_firestore"
    }
  },
  tickets: {
    registros: "riskmann_tickets",
  },
};
